import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory, useRouteMatch } from "react-router-dom";
import parse from 'html-react-parser';
import InfiniteScroll from 'react-infinite-scroll-component';
import { setPageClass, setUpHeader } from "../../../store/features/slice-ui";
import { fetchDoctorsFilter, selectFilterItem, clearFilterItems } from "../../../store/features/slice-doctors";
import { renderMore} from "../../../store/features/slice-doctors";
import PageHead from "../../../components/PageHead";
import PageContent from "../../../components/PageContent";
import DoctorListItem from "../../../components/Cards/Cta";
import CenterCard from "../../../components/Cards/Contact";
import Section from "../../../components/Section";
import Loading from "../../../components/Loading";
import {Word} from "../../../components/Word";
import Select from "../../../components/Form/Select";




const SelectDoctorByCentre = () => {
  const dispatch = useDispatch();
  const histroy = useHistory();
  const match = useRouteMatch();
  const doctorsIDs = useSelector((state) => state.doctors.list['rp']);
  const doctorsListBasic = useSelector((state) => state.doctors.basic);
  const accountData = useSelector((state) => state.account.data);
  const currentLoaded = useSelector((state) => state.doctors.currentLoaded['rp']);
  const centresListBasic = useSelector((state) => state.centres.basic);
  const filters = useSelector((state) => state.doctors.filters['rp']);
  const fields = useSelector((state) => state.doctors.taxonomies.fields);
  const [fieldsSelect, setFieldsSelect] = useState(filters.fields);
  let { slug } = useParams();
  useEffect(() => {
    dispatch(setPageClass("page-referbycenter-selectdoctor"));
    dispatch(setUpHeader({
      show: true,
      logo: false,
      back: true,
      profile: true,
      search: true
    }));
  }, [dispatch]);

  useEffect(() => {
    if(centresListBasic && Object.keys(centresListBasic).length > 0 && !centresListBasic[slug]){
      histroy.replace('/refer-patient/centre');
    }
  }, [centresListBasic, histroy, slug]);

  useEffect(() => {
    dispatch(clearFilterItems('rp'));
    setFieldsSelect([])
    dispatch(selectFilterItem( {data: slug , filterItem: 'doctor_centre', filter: 'rp'}));
    dispatch(fetchDoctorsFilter('rp'));
  }, [dispatch, slug])

  const renderDoctors = () => {
    return doctorsListBasic && doctorsIDs && currentLoaded ? doctorsIDs.slice(0, currentLoaded).map(id => (
      doctorsListBasic[id] ? <DoctorListItem
          key={id}
          image={doctorsListBasic[id].profileImage}
          title={parse(doctorsListBasic[id].salutation+" "+doctorsListBasic[id].name)}
          subtitle={doctorsListBasic[id].tags && doctorsListBasic[id].tags.length > 0 ? doctorsListBasic[id].tags.map((tag, index) => index > 0 ? ', '+tag.name : tag.name)  : null}
          isCentered
          icon="chevron_right"
          link={`${match.url}/${id}`}
          isFavourite = {accountData && accountData.favourites.includes(doctorsListBasic[id].slug) ? true : false}
      /> : null
    )) : null;
  }

  const handleFieldsSelectChange = (payload) => {
    let arr = [payload]
    setFieldsSelect(payload);
    dispatch(selectFilterItem( {data: arr , filterItem: 'fields', filter: 'rp'}));
    dispatch(selectFilterItem( {data: slug , filterItem: 'doctor_centre', filter: 'rp'}));
    dispatch(fetchDoctorsFilter('rp'));
  };
  
  
  return (
    <>
      <PageHead 
        className="page-referbycentre-selectdoctor--page-head"
        title="Refer a Patient"
        subtitle="By Centre"
      />
      <PageContent className="page-referbycentre-selectdoctor--page-content">
        <Section className="split-content w-40-60">
          <Section className="page-referbycentre-selectdoctor--centre">
            {centresListBasic && Object.keys(centresListBasic).length > 0 && centresListBasic[slug] ? 
              <div className="page-referbycentre-selectdoctor--centre-content">
                <h3><Word value="Centre" /></h3>
                <CenterCard
                    image={centresListBasic[slug].image}
                    title={centresListBasic[slug].title}
                    minimal
                />
              </div>
            : null }
          </Section>
          <Section className="page-referbycentre-selectdoctor--content">
          {doctorsIDs ? 
            <>
              <Section className="page-referbycentre-selectdoctor--filter">
                <h3><Word value="Please select a specialist" /></h3>
                {fields && fields.length > 0 ? 
                    <Select 
                      name="fields"
                      id={'fields'}
                      title="Speciality"
                      options={fields.map(item => ({ 'value': item['slug'], 'label': item['name'] }))}
                      onChange={handleFieldsSelectChange}
                      value={fieldsSelect}
                    />
                : null}
              </Section>
              {doctorsIDs.length > 0 ?
                <Section className="page-referbycentre-selectdoctor--list attached-list">
                  <InfiniteScroll
                    dataLength={currentLoaded}
                    next={() => dispatch(renderMore('rp'))}
                    hasMore={(currentLoaded < doctorsIDs.length)}
                    loader={<Loading />}
                    scrollThreshold={0.7}
                  >
                    {renderDoctors()}
                  </InfiniteScroll>
                </Section>
              : null}
            </>
          : null }
          </Section>
        </Section>
      </PageContent>
    </>
  );
};

export default SelectDoctorByCentre;
